module.exports = __webpack_public_path__ + "static/media/app_bild.6cbc06a3.jpg";